<template lang="html">
  <div class="container">
    <div class="cover">
      <Photo
        source="cdn"
        v-if="coverId"
        :img-id="coverId"
        width="150px"
        height="150px"
        radius="5px"
      />
    </div>
    <div class="cover">
      <van-count-down
        ref="countDown"
        :time="countDownDuration * 1000"
        :auto-start="false"
        format="mm:ss"
        @finish="finished"
        style="font-weight:bold;font-size:1em;"
      />
    </div>
    <div style="margin:30px 0;padding: 0 20px;">
      <van-slider
        v-model="audio.audioPlayPercentage"
        active-color="#1989fa"
        bar-height="4px"
        @change="sliderOnChange"
      >
        <div
          slot="button"
          class="custom-button"
        >
          {{ audio.audioPlayPercentage }}%
        </div>
      </van-slider>
    </div>
    <audio v-if="trailUrl"
      ref="audiofile"
      preload="auto"
      @pause="audioOnPause"
      @play="audioOnPlay"
      @loadedmetadata="audioLoadedMetaData"
      @timeupdate="audioTimeUpdated"
      style="display:block;"
    >
      <!-- <source src="http://cdn.lizhi.fm/audio/2019/11/11/5076630668405625862_hd.mp3" type="audio/mpeg"> -->
      <source
        :src="trailUrl"
        type="audio/mpeg"
      />
    </audio>

    <van-grid clickable :column-num="3" :border="false">
      <van-grid-item text="开始" icon="play-circle-o" @click="start" />
      <van-grid-item text="暂停" icon="pause-circle-o" @click="pause" />
      <van-grid-item text="重听" icon="replay" @click="reset" />
    </van-grid>
  </div>
</template>

<script>
  import Photo from './photo.vue'
  import Vue from 'vue'
  import { Image } from 'vant'
  import { CountDown } from 'vant'
  import { Slider } from 'vant'
  Vue.use(Image)
  Vue.use(CountDown)
  Vue.use(Slider)

  export default {
    components: {
      Photo
    },
    data () {
      return {
        coverId: null,
        audio: {
          duration: 0, // 总时长
          current: 0, // 当前播放时间,
          audioPlayPercentage: 0
        },
        // trail: {
        //   private_cdns: [],
        //   public_cdns: []
        // }
        trailUrl: null
      }
    },
    props: {
      episodeId: Number
    },
    computed: {
      countDownDuration: function () {
        return this.audio.duration - this.audio.current
      },
      trail_url () {
        let url
        if (this.trail) {
          if (this.trail.public_cdns.length > 0) {
            url = this.trail.public_cdns[0].url
          } else if (this.trail.private_cdns.length > 0) {
            url = this.trail.private_cdns[0].cdn_url
          }
        } else {
          url = null
        }
        window.console.log("trail_url")
        window.console.log(url)
        return url
      }
    },
    methods: {
      start () {
        this.$refs.countDown.start()
        this.$refs.audiofile.play()
      },
      pause () {
        this.$refs.countDown.pause()
        this.$refs.audiofile.pause()
      },
      reset () {
        this.$refs.countDown.reset()
        this.$refs.audiofile.currentTime = 0
      },
      finished () {
        // this.$toast('倒计时结束')
      },
      audioOnPause () {

      },
      audioOnPlay () {

      },
      audioLoadedMetaData (e) {
        this.audio.duration = e.srcElement.duration
      },
      audioTimeUpdated (e) {
        let duration = e.srcElement.duration
        let current = e.srcElement.currentTime
        let currentPercentage = Math.round(
          (current / duration) * 100)
        let audio = {
          duration: duration,
          current: current,
          audioPlayPercentage: currentPercentage
        }
        this.audio = audio
      },
      sliderOnChange (value) {
        let current = this.audio.duration * (value / 100)
        this.$refs.audiofile.currentTime = current
      }
    },
    mounted () {
      window.console.log("试听组件")
      let that = this
      that.$api.episode.detail(that.episodeId).then(res => {
        window.console.log("episode detail:")
        window.console.log(res.data)
        that.coverId = res.data.cover
        let trailId = res.data.trails[0]
        if (trailId) {
          that.$api.audio.detail(trailId).then(res => {
            // that.trail = res.data
            window.console.log("获取到试听音频")
            window.console.log(res.data)
            that.trailUrl = res.data.private_cdns[0].cdn_url
          })
        }
        // that.$api.audio.detail(res.data.audios[0]).then(res => {
        //   if (res.data.trail) {
        //     that.$api.audio.detail(res.data.trail).then(res => {
        //       that.trail = res.data
        //       window.console.log("试听：")
        //       window.console.log(res.data)
        //     })
        //   }
        // })
      })
    }
  }
</script>

<style lang="css" scoped>
  .container {
    /* text-align: center; */
    padding: 30px;
  }
  .custom-button {
    background: #1989fa;
    padding: 2px 10px;
    border-radius: 10px;
    color: #fff;
    font-size: 0.8em;
  }
  .cover {
    display: flex;
    justify-content: center;
  }
</style>
